import Joi from "joi";

export const liabilityDisclaimerViewed = Joi.object({});
